import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from './ng-zorro/ng-zorro.module';
import { LanguageSelectorComponent } from './language-selector/language-selector.component';
import { VersionComponent } from './version/version.component';
import { LoaderComponent } from './loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';



@NgModule({
	declarations: [
		LanguageSelectorComponent,
		VersionComponent,
		LoaderComponent,
		BreadcrumbComponent,
	],
	imports: [
		CommonModule,
		NgZorroModule,
		TranslateModule.forChild(),
		RouterModule,
	],
	exports: [
		NgZorroModule,
		LanguageSelectorComponent,
		VersionComponent,
		LoaderComponent,
		BreadcrumbComponent,
	]
})
export class LayoutModule { }
